export enum TipoPerfil {
  RESPONSAVEL_FAMILIAR = 1,
  REPRESENTANTE_LEGAL = 2,
  INTEGRANTE_FAMILIAR = 3,
}
